var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Fragment } from "react";
import * as React from "react";
import { ReactElementFactory, SurveyElementBase, Survey, attachKey2click } from "survey-react-ui";
import { SurfacePlaceholder } from "../components/SurfacePlaceholder";
var TabLogicAddButtonComponent = /** @class */ (function (_super) {
    __extends(TabLogicAddButtonComponent, _super);
    function TabLogicAddButtonComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TabLogicAddButtonComponent.prototype, "model", {
        get: function () {
            return this.props.button;
        },
        enumerable: false,
        configurable: true
    });
    TabLogicAddButtonComponent.prototype.getStateElement = function () {
        return this.model;
    };
    TabLogicAddButtonComponent.prototype.renderElement = function () {
        var _this = this;
        var buttonClassName = "svc-logic-tab__content-action svc-btn" + ((this.model.enabled !== undefined && !this.model.enabled) ? " svc-logic-tab__content-action--disabled" : "");
        return attachKey2click(React.createElement("div", { role: "button", onClick: function (e) {
                e.stopPropagation();
                _this.model.action();
            }, className: buttonClassName, title: this.model.title },
            React.createElement("span", { className: "svc-btn__text" }, this.model.title)));
    };
    return TabLogicAddButtonComponent;
}(SurveyElementBase));
export { TabLogicAddButtonComponent };
ReactElementFactory.Instance.registerElement("svc-tab-logic-add-button", function (props) {
    return React.createElement(TabLogicAddButtonComponent, props);
});
var TabLogicComponent = /** @class */ (function (_super) {
    __extends(TabLogicComponent, _super);
    function TabLogicComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TabLogicComponent.prototype, "model", {
        get: function () {
            return this.props.data;
        },
        enumerable: false,
        configurable: true
    });
    TabLogicComponent.prototype.getStateElement = function () {
        return this.model;
    };
    TabLogicComponent.prototype.renderElement = function () {
        var logic = this.model;
        var rootClass = "svc-creator-tab__content svc-logic-tab";
        var content = this.renderViewContent();
        return React.createElement("div", { className: rootClass }, content);
    };
    TabLogicComponent.prototype.renderViewContent = function () {
        var logicTabClassName = "svc-plugin-tab__content svc-logic-tab svc-logic-tab__content " + (this.model.hasItems ? "" : "svc-logic-tab--empty");
        var addLogic = !this.model.readOnly ? React.createElement(TabLogicAddButtonComponent, { button: this.model.addNewButton }) : undefined;
        return (React.createElement(Fragment, null,
            React.createElement("div", { className: logicTabClassName }, this.model.hasItems ?
                (React.createElement(React.Fragment, null,
                    React.createElement(Survey, { model: this.model.itemsSurvey }),
                    addLogic))
                : (React.createElement("div", { className: "svc-logic-tab__content-empty" },
                    React.createElement(SurfacePlaceholder, { name: "logic", placeholderTitleText: this.model.placeholderTitleText, placeholderDescriptionText: this.model.placeholderDescriptionText }),
                    addLogic)))));
    };
    return TabLogicComponent;
}(SurveyElementBase));
export { TabLogicComponent };
ReactElementFactory.Instance.registerElement("svc-tab-logic", function (props) {
    return React.createElement(TabLogicComponent, props);
});
